(function (Drupal, $, once, drupalSettings) {
  'use strict';

  // Add an anchor ID for 'back-to-top' link.
  document.querySelector('body').id = 'top';

  // Scroll to #Anchor action.
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      // DOM objects we'll be working with.
      const primaryHeader = document.querySelector('header');
      const profileHeader = document.querySelector('#profile-header');
      const anchorItem = document.querySelector(this.getAttribute('href'));

      let primaryHeaderHeight = primaryHeader.getBoundingClientRect().height;
      let profileHeaderHeight = profileHeader.getBoundingClientRect().height;
      let anchorItemTop = anchorItem.getBoundingClientRect().top;

      // If anchorItemTop is negative, it means we will be scrolling upward and
      // will encounter the primary header. Otherwise, we just need to clear the
      // scroll position from under regular minimized profile header. Subtract a
      // single pixel to account for the divider lines separating sections.
      let offset = -(((anchorItemTop < 0) ? primaryHeaderHeight : profileHeaderHeight) - 1);
      window.scrollTo({
        top: anchorItemTop + window.pageYOffset + offset,
        behavior: 'smooth'
      });
    });
  });

  Drupal.behaviors.ucwsProfileCommon = {
    attach: function (context, settings) {
      // Subsection open/close state control.
      $(".minimal-accordion-item-collapse").on('show.bs.collapse', function (e) {
        // Show subsection.
        $(e.target)
        .prev('.minimal-accordion-item-heading')
        .addClass('active');
      }).on('hide.bs.collapse', function (e) {
        // Hide subsection.
        $(e.target)
        .prev('.minimal-accordion-item-heading')
        .removeClass('active');
      });
    }
  };

  Drupal.behaviors.ucwsProfileCommonExternalLinks = {
    attach: function (context, settings) {
      $(once('addSearchIconBehaviour', '.profile-section.publications-container .publication-external-links-container a, .contact-section.web-presence a')).each(function () {
        var favicon = 'https://www.google.com/s2/favicons?domain=' + this.href.match(/:\/\/(.[^/]+)/)[1];
        $('<div />').addClass("external-link-favicon").css({
          "background": "url(" + favicon + ") left center no-repeat",
          "padding-left": "30px"
        }).insertBefore($(this).parent('p'));
      });
    }
  };

  Drupal.behaviors.ucwsProfileStickyHeader = {
    attach: function (context, settings) {

      // DOM objects we'll be working with.
      const primaryHeader = document.querySelector('header');
      const profileHeader = document.querySelector('#profile-container');
      const sidebarNav = document.querySelector('#sidebar-nav');

      // Need to coordinate with these values in CSS.
      let profileHeaderStickyHeight = 100;
      let sidebarNavMarginHeight = 50;
      let sidebarNavMinTopPosition = profileHeaderStickyHeight + sidebarNavMarginHeight;

      function stickHead(event) {

        // Profile header display.
        if (primaryHeader.getBoundingClientRect().bottom <= 0) {
          // Primary UCalgary header left the screen - shrink profile header.
          profileHeader.classList.add('sticky-head');
        }
        else if (document.documentElement.scrollTop === 0) {
          // Scrolled back to top of page - let Profile header grow.
          profileHeader.classList.remove('sticky-head');
        }

        // Sub-menu / Primary header interaction.
        let primaryHeaderBottom = primaryHeader.getBoundingClientRect().bottom;
        if (primaryHeaderBottom >= profileHeaderStickyHeight) {
          // Sidebar Nav is sticky in relation to bottom of the profile header,
          // but we need it to move in relation to the primary header too.
          let sidebarNavScrollingPosition = primaryHeaderBottom + sidebarNavMarginHeight;
          sidebarNav.style.top = sidebarNavScrollingPosition + 'px';
        }
        else {
          sidebarNav.style.top = sidebarNavMinTopPosition + 'px';
        }
      }

      window.addEventListener('scroll', stickHead);
    }
  };
})(Drupal, jQuery, once, drupalSettings);
